/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import IFlujos from 'Infotrack@Modelos/smartStock/flujos/entidades/flujos';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { AnyAction } from 'redux';

export interface IEstadoFlujos {
    estadoFormulario: boolean;
    entidadFlujos: IFlujos | null;
    recargarTabla: boolean;
    tipoFormulario: TipoFormulario;
}

export const estadoIncial: IEstadoFlujos = {
    entidadFlujos: null,
    estadoFormulario: false,
    recargarTabla: false,
    tipoFormulario: TipoFormulario.Creacion,
};

export enum acciones {
    CAMBIAR_ESTADO_FORMULARIO = 'CAMBIAR_ESTADO_FORMULARIO',
    RECARGAR_TABLA = 'RECARGAR_TABLA',
}

export const reductor = (estado: IEstadoFlujos, { type, payload }: AnyAction) => {
    switch (type) {
        case 'CAMBIAR_ESTADO_FORMULARIO': {
            return {
                ...estado,
                entidadFlujos: payload ? payload.entidadFlujos : null,
                estadoFormulario: !estado.estadoFormulario,
                tipoFormulario: payload ? payload.tipoFormulario : estado.tipoFormulario,
            };
        }
        case 'RECARGAR_TABLA':
            return {
                ...estado,
                recargarTabla: !estado.recargarTabla,
            };

        default:
            return estado;
    }
};
